<template>
  <v-expansion-panel>
    <v-expansion-panel-header><span v-html="question"></span></v-expansion-panel-header>
    <v-expansion-panel-content><pre><span v-html="answer"></span></pre></v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
export default {
  props: {
    question: String,
    answer: String
  }
}
</script>
